<template>
  <vue-client-only>
    <div class="no-delivery-warning">
      <template v-if="isShow">
        По вашему запросу нет товаров доступных для&nbsp;оформления заказа.
        Возможно они скоро появятся или временно недоступна <a class="link-blue" href="/delivery" target="_blank">доставка</a> в&nbsp;ваш регион.
        Попробуйте <span ref="changeRegion" class="link-blue" @click="changeRegion">изменить регион доставки</span> или проверьте наличие товаров в&nbsp;других категориях.
      </template>
    </div>
  </vue-client-only>
</template>

<script>
import { mapGetters } from 'vuex';
import VueClientOnly from 'vue-client-only';

export default {
  name: 'no-delivery-warning',

  components: {
    VueClientOnly
  },

  computed: {
    ...mapGetters({
      CITY: 'user/city',
    }),

    isShow() {
      const noWaysToGet = !this.CITY.receivingMethods.length;
      const onlyThirdparty = this.CITY.receivingMethods.length === 1 && this.CITY.receivingMethods.includes('thirdparty');
      return noWaysToGet || onlyThirdparty;
    },
  },

  methods: {
    async changeRegion() {
      const city = await this.$city.changeCity();
      this.$city.requestConfirmation({ city, reloadPage: true });
    },
  }
};
</script>
